import type { Translation } from '../../types';
import type { subscriptions as en } from '../en/subscriptions';

/** Dịch vụ đã bán (Bán hàng & tài chính › Dịch vụ): hạn, thanh toán, tạm ngưng, huỷ. Lời thường. */
export const subscriptions: Translation<typeof en> = {
  crumb: 'Bán hàng & tài chính',
  title: 'Dịch vụ',
  subtitle: 'Mọi dịch vụ khách đã mua (hosting, máy chủ, email…): khi nào đến hạn, đã trả tiền chưa và đã có chuyện gì với dịch vụ.',
  search: 'Tên miền, tên máy chủ hoặc khách hàng',
  allStates: 'Mọi trạng thái',
  empty: 'Không có dịch vụ nào phù hợp.',
  back: 'Quay lại danh sách dịch vụ',
  views: { label: 'Danh sách dịch vụ', all: 'Tất cả', waiting: 'Chờ cấp phát', due: 'Sắp đến hạn', overdue: 'Quá hạn', days: 'Khoảng đến hạn', withinDays: 'Trong {{count}} ngày', limit: 'Đang hiển thị tối đa {{count}} dòng mỗi nhóm. Có thể còn dữ liệu; dùng tab Tất cả và bộ lọc để tra cứu đầy đủ.', paidItems: 'Đã thanh toán, chưa bắt đầu cấp phát', order: 'Xem đơn hàng', paidAmount: 'Số tiền đã giữ', workflow: 'Xử lý cấp phát', openWorkflow: 'Xem quy trình', notStarted: 'Chưa bắt đầu' },
  pager: { previous: 'Trang trước', next: 'Trang sau', page: 'Trang {{n}}' },
  col: {
    service: 'Dịch vụ',
    customer: 'Khách hàng',
    plan: 'Gói',
    cycle: 'Chu kỳ',
    state: 'Trạng thái',
    due: 'Hạn',
    amount: 'Giá mỗi chu kỳ',
  },
  state: {
    PENDING: 'Chờ thanh toán',
    PROVISIONING: 'Đang khởi tạo',
    ACTIVE: 'Đang hoạt động',
    OVERDUE: 'Quá hạn',
    SUSPENDED: 'Tạm ngưng',
    CANCELLATION_PENDING: 'Kết thúc khi hết kỳ',
    TERMINATED: 'Đã huỷ',
    CANCELLED: 'Đã huỷ đơn',
    FRAUD: 'Đóng băng (gian lận)',
  },
  suspendReason: {
    NON_PAYMENT: 'chưa thanh toán',
    ABUSE: 'vi phạm, lạm dụng',
    CUSTOMER_REQUEST: 'theo yêu cầu của khách',
    OTHER: 'lý do khác',
  },
  service: {
    ORDERED: 'Đã đặt',
    PROVISIONING: 'Đang tạo',
    ACTIVE: 'Đang chạy',
    SUSPENDED: 'Đã tạm ngưng bên nhà cung cấp',
    TERMINATED: 'Đã huỷ bên nhà cung cấp',
    FAILED: 'Không tạo được',
    UNKNOWN: 'Chưa rõ kết quả (đang đối chiếu với nhà cung cấp)',
  },
  due: {
    none: 'Không có hạn',
    ended: 'Đã kết thúc',
    later_one: 'Còn {{count}} ngày',
    later_other: 'Còn {{count}} ngày',
    soon_one: 'Còn {{count}} ngày',
    soon_other: 'Còn {{count}} ngày',
    today: 'Đến hạn hôm nay',
    overdue_one: 'Quá hạn {{count}} ngày',
    overdue_other: 'Quá hạn {{count}} ngày',
  },
  cycle: {
    ONCE: 'Một lần',
    H1: '1 giờ',
    M1: '1 tháng',
    M3: '3 tháng',
    M6: '6 tháng',
    M12: '1 năm',
    M24: '2 năm',
    M36: '3 năm',
    M48: '4 năm',
    M60: '5 năm',
  },
  fulfilment: { PROVISIONED: 'Khởi tạo tự động', MANUAL: 'Nhân viên khởi tạo' },
  autoRenew: { on: 'Tự trừ ví khi đủ tiền', off: 'Không tự gia hạn' },
  detail: {
    overview: 'Tổng quan',
    customer: 'Khách hàng',
    product: 'Sản phẩm',
    plan: 'Gói',
    cycle: 'Chu kỳ',
    state: 'Trạng thái',
    nextDue: 'Đã trả đến ngày',
    anchor: 'Bắt đầu từ ngày',
    amount: 'Giá mỗi chu kỳ (chưa VAT)',
    autoRenew: 'Gia hạn',
    delivery: 'Cách khởi tạo',
    service: 'Bên nhà cung cấp',
    paidUntil: 'Đã trả đến (bên nhà cung cấp)',
    hold: 'Không tạm ngưng trước ngày',
    lifecycle: 'Cài đặt quá hạn đang áp dụng',
    lifecycleText: 'Tạo đơn gia hạn trước hạn {{invoice}} ngày · tạm ngưng sau hạn {{suspend}} ngày · huỷ sau hạn {{terminate}} ngày',
    lifecycleOff: 'Không bao giờ tự tạm ngưng hay tự huỷ',
    periods: 'Các kỳ đã trả',
    renewals: 'Đơn gia hạn',
    calendar: 'Lịch quá hạn',
    history: 'Lịch sử trạng thái',
    actions: 'Yêu cầu của nhân viên',
    none: 'Chưa có.',
    qrCode: 'Nội dung chuyển khoản {{code}}',
    operations: 'Nhật ký cấp phát',
    operationsHint: 'Những gì đã gửi tới nhà cung cấp cho dịch vụ này, mới nhất trước (giờ Việt Nam).',
    orders: 'Đơn hàng & hoá đơn',
    cancellations: 'Yêu cầu huỷ',
  },
  delivery: {
    col: 'Tình trạng cấp phát',
    none: 'Chưa gửi gì tới nhà cung cấp',
    workflow: 'Cấp phát đã dừng ({{code}})',
    attempts_one: '{{count}} lần thử',
    attempts_other: '{{count}} lần thử',
  },
  opName: {
    create: 'Tạo tài khoản',
    suspend: 'Tạm ngưng',
    unsuspend: 'Mở lại',
    terminate: 'Huỷ',
    change_plan: 'Đổi gói',
    renew: 'Gia hạn',
    reset_password: 'Đặt mật khẩu',
    ssl_auto: 'Chạy AutoSSL',
    ssl_install: 'Cài chứng chỉ',
    domain_add: 'Thêm tên miền',
    domain_remove: 'Gỡ tên miền',
    db_create: 'Tạo cơ sở dữ liệu',
    db_delete: 'Xoá cơ sở dữ liệu',
    ftp_create: 'Tạo tài khoản FTP',
    ftp_delete: 'Xoá tài khoản FTP',
    backup_create: 'Sao lưu',
    backup_restore: 'Khôi phục bản sao lưu',
    apply: 'Áp dụng bản ghi DNS',
    repair: 'Sửa chỗ lệch DNS',
    dnssec_enable: 'Bật DNSSEC',
    dnssec_disable: 'Tắt DNSSEC',
    allow_transfer: 'Cho phép sao chép vùng',
    native_template: 'Áp mẫu của máy chủ DNS',
  },
  opStatus: {
    QUEUED: 'Chờ gửi',
    SENDING: 'Đang gửi',
    RUNNING: 'Nhà cung cấp đang làm',
    SUCCEEDED: 'Đã xong',
    REFUSED: 'Nhà cung cấp từ chối',
    FAILED: 'Không làm được',
    UNKNOWN: 'Chưa rõ kết quả',
    CANCELLED: 'Đã huỷ',
  },
  opCol: { op: 'Thao tác', status: 'Trạng thái', attempts: 'Số lần thử', detail: 'Chi tiết', at: 'Lúc tạo', finished: 'Xong lúc', action: 'Xử lý' },
  orderCol: { order: 'Đơn hàng', action: 'Loại', status: 'Trạng thái', amount: 'Số tiền', invoice: 'Hoá đơn', at: 'Lúc' },
  orderAction: { NEW: 'Dịch vụ mới', RENEW: 'Gia hạn', CHANGE: 'Thay đổi' },
  cancelCol: { timing: 'Khi nào', state: 'Trạng thái', reason: 'Lý do', at: 'Lúc yêu cầu', done: 'Xong lúc' },
  cancelState: { REQUESTED: 'Đã yêu cầu', ACCEPTED: 'Đã chấp nhận', REJECTED: 'Bị từ chối', WITHDRAWN: 'Đã rút lại', DONE: 'Đã xong' },
  hosting: {
    title: 'Kỹ thuật (cPanel)',
    subtitle: 'Tài khoản hosting theo dữ liệu của hệ thống; bấm "Đồng bộ từ máy chủ" để đọc lại trên máy chủ.',
    loadFailed: 'Không đọc được phần kỹ thuật của dịch vụ.',
    username: 'Tên đăng nhập cPanel',
    domain: 'Tên miền chính',
    server: 'Máy chủ',
    ip: 'Địa chỉ IP',
    nameservers: 'Name server',
    connection: 'Kết nối',
    kernel: 'Trạng thái trong hệ thống',
    panel: 'Trên máy chủ',
    checked: 'Lần đọc máy chủ gần nhất',
    drift: 'Lệch với máy chủ',
    driftNone: 'Không lệch',
    driftMissing: 'Tài khoản không còn trên máy chủ',
    driftStates: 'Hệ thống: {{ours}} · Máy chủ: {{theirs}}',
    attention: 'Cần nhân viên xử lý',
    attentionHint: 'Có thao tác cấp phát chưa rõ kết quả hoặc bị từ chối: xem Nhật ký cấp phát bên dưới.',
    created: 'Đã tạo trên máy chủ lúc',
    released: 'Đã giải phóng lúc',
    notYet: 'Chưa',
    shared: 'IP dùng chung',
    dedicated: 'IP riêng',
    usage: 'Mức dùng',
    usageNone: 'Chưa có số liệu mức dùng (hệ thống đọc từ máy chủ mỗi giờ).',
    meter: { DISK_MB: 'Dung lượng đĩa', INODES: 'Số tệp (inode)', BANDWIDTH_MB: 'Băng thông tháng này' },
    unlimited: 'không giới hạn',
    panelStatus: { PROVISIONING: 'Đang tạo', ACTIVE: 'Đang chạy', SUSPENDED: 'Đang tạm ngưng', TERMINATED: 'Đã xoá', FAILED: 'Lỗi', UNKNOWN: 'Chưa rõ' },
    signIn: 'Đăng nhập cPanel',
    signInTitle: 'Đăng nhập cPanel bằng tài khoản {{username}}',
    signInIntro: 'Tạo một đường dẫn đăng nhập một lần vào cPanel của khách (hiệu lực vài phút). Đường dẫn không được lưu; lần đăng nhập được ghi nhật ký kèm lý do.',
    signInReady: 'Đường dẫn đã sẵn sàng: chỉ dùng được một lần và hết hạn lúc {{at}}.',
    signInOpen: 'Mở cPanel',
    password: 'Đặt mật khẩu cPanel',
    passwordTitle: 'Mật khẩu cPanel mới cho {{username}}',
    passwordIntro: 'Đặt ngay mật khẩu của tài khoản cPanel. Mật khẩu chỉ gửi tới máy chủ và không được lưu: báo cho khách qua kênh an toàn.',
    passwordField: 'Mật khẩu mới',
    passwordHint: 'Ít nhất {{min}} ký tự, có ít nhất hai loại ký tự (chữ thường, chữ hoa, số, ký hiệu), không chứa tên đăng nhập.',
    passwordDone: 'Đã đặt mật khẩu trên máy chủ.',
    refresh: 'Đồng bộ từ máy chủ',
    refreshTitle: 'Đọc lại {{username}} trên máy chủ',
    refreshIntro: 'Đọc tài khoản trên máy chủ ngay bây giờ: trạng thái, máy chủ, địa chỉ IP và name server (dùng sau khi sửa tay trên máy chủ).',
    refreshDone: 'Đã đọc lại từ máy chủ.',
    autossl: 'Chạy AutoSSL',
    autosslTitle: 'Chạy AutoSSL cho {{domain}}',
    autosslIntro: 'Yêu cầu máy chủ cấp hoặc gia hạn chứng chỉ miễn phí cho các tên miền của tài khoản. Yêu cầu được xếp hàng và gửi trong khoảng một phút; kết quả hiện ở Nhật ký cấp phát.',
    autosslDone: 'Đã xếp hàng chạy AutoSSL.',
    resolve: 'Xử lý',
    resolveTitle: 'Xử lý thao tác "{{op}}" chưa rõ kết quả',
    resolveIntro: 'Máy chủ không trả lời rõ ràng. Kiểm tra tài khoản trên máy chủ (WHM › List Accounts) rồi chọn điều đã xảy ra.',
    resolveChoice: 'Trên máy chủ đã xảy ra gì',
    resolution: {
      DONE: 'Đã làm xong trên máy chủ',
      NOT_DONE: 'Chưa làm: gửi lại',
      ABANDON: 'Bỏ (thao tác tạo thì dịch vụ không tạo được và tiền đang giữ về ví khách)',
    },
    providerRef: 'Tên đăng nhập cPanel trên máy chủ',
    providerRefHint: 'Để trống: {{username}}. Tên khác: hệ thống kiểm theo quy tắc của máy chủ rồi ghi tên đó cho tài khoản.',
    resolveDone: 'Đã ghi nhận. Dịch vụ sẽ cập nhật trong vài phút.',
  },
  periodCol: { kind: 'Loại', from: 'Từ ngày', to: 'Đến ngày', amount: 'Số tiền', reason: 'Lý do' },
  period: { FIRST: 'Kỳ đầu', RENEWAL: 'Gia hạn', CHANGE: 'Đổi gói', EXTENSION: 'Cộng thời hạn miễn phí', TRIAL: 'Dùng thử' },
  renewalCol: { due: 'Cho hạn ngày', state: 'Trạng thái', paidBy: 'Trả bằng', amount: 'Số tiền (gồm VAT)', payment: 'Thanh toán' },
  renewal: { OPEN: 'Chờ thanh toán', PAID: 'Đã thanh toán', CANCELLED: 'Đã huỷ', LAPSED: 'Hết hiệu lực' },
  paidBy: { WALLET: 'Ví', TRANSFER: 'Chuyển khoản (QR)' },
  calendarCol: { due: 'Hạn', step: 'Bước', day: 'Ngày', at: 'Lúc' },
  step: {
    RENEWAL_ORDER: 'Đã tạo đơn gia hạn',
    REMINDER: 'Đã gửi nhắc gia hạn',
    OVERDUE: 'Chuyển sang quá hạn',
    UNPAID_SIGNAL: 'Đã hẹn tạm ngưng bên nhà cung cấp',
    LATE_FEE: 'Đã cộng phí trả chậm',
    SUSPENDED: 'Đã tạm ngưng',
    TERMINATED: 'Đã huỷ dịch vụ',
    TERMINATION_NOTICE: 'Đã báo trước việc huỷ',
  },
  dayBefore_one: 'Trước hạn {{count}} ngày',
  dayBefore_other: 'Trước hạn {{count}} ngày',
  dayAfter_one: 'Sau hạn {{count}} ngày',
  dayAfter_other: 'Sau hạn {{count}} ngày',
  dayDue: 'Đúng ngày đến hạn',
  historyCol: { from: 'Từ', to: 'Sang', reason: 'Lý do', at: 'Lúc' },
  reason: {
    SERVICE_PROVISIONED: 'Dịch vụ đã được khởi tạo',
    UNPAID_AT_DUE: 'Đến hạn mà chưa thanh toán',
    NON_PAYMENT: 'Chưa thanh toán',
    PAID: 'Đã thanh toán',
    EXTENDED: 'Nhân viên cộng thời hạn',
    CANCELLED_AT_PERIOD_END: 'Kết thúc khi hết kỳ',
    ORDER_PAID: 'Đơn hàng đã được thanh toán',
  },
  actionCol: { kind: 'Yêu cầu', reason: 'Lý do', state: 'Trạng thái', at: 'Lúc yêu cầu' },
  action: { SUSPEND: 'Tạm ngưng', UNSUSPEND: 'Mở lại', BILLING_PAID: 'Báo nhà cung cấp đã thanh toán', TERMINATE: 'Huỷ dịch vụ' },
  actionState: { PENDING: 'Đang chờ', DONE: 'Đã xong', FAILED: 'Không thực hiện được' },
  op: {
    completeDelivery: 'Hoàn tất cấp phát',
    completeDeliveryTitle: 'Xác nhận bàn giao {{label}}',
    completeDeliveryIntro: 'Chỉ xác nhận sau khi đã cấp phát và bàn giao dịch vụ cho khách. Hệ thống sẽ kích hoạt dịch vụ, bắt đầu kỳ đầu, quyết toán tiền đã giữ và lập hóa đơn.',
    deliveryDone: 'Đã xác nhận bàn giao và kích hoạt dịch vụ. Kỳ đầu, quyết toán và hóa đơn đã được ghi nhận.',
    cancelDelivery: 'Không thể cấp phát',
    cancelDeliveryTitle: 'Không thể cấp phát {{label}}',
    cancelDeliveryIntro: 'Dùng khi không thể giao dịch vụ cho khách. Dịch vụ bị huỷ, tiền đang giữ trả về ví của khách; không quyết toán, không lập hóa đơn. Không hoàn tác được.',
    deliveryCancelled: 'Đã huỷ dịch vụ không thể cấp phát. Tiền đang giữ đã trả về ví của khách.',

    extend: 'Cộng thời hạn',
    extendTitle: 'Cộng thời hạn miễn phí cho {{label}}',
    extendIntro: 'Ngày đến hạn lùi thêm số ngày nhập vào, không thu tiền. Trên {{days}} ngày cần thêm một quyền riêng.',
    days: 'Số ngày',
    suspend: 'Tạm ngưng',
    suspendTitle: 'Tạm ngưng {{label}}',
    suspendIntro: 'Dịch vụ ngừng chạy bên nhà cung cấp. Tạm ngưng do nhân viên thì khách trả tiền cũng không tự mở lại.',
    suspendReason: 'Vì sao',
    unsuspend: 'Mở lại',
    unsuspendTitle: 'Mở lại {{label}}',
    unsuspendIntro: 'Dịch vụ chạy lại bên nhà cung cấp.',
    terminate: 'Huỷ dịch vụ',
    terminateTitle: 'Huỷ {{label}}',
    terminateIntro: 'Huỷ khi hết kỳ: dịch vụ không gia hạn nữa và kết thúc vào ngày đến hạn. Huỷ ngay: dịch vụ bị huỷ bây giờ và dữ liệu bên nhà cung cấp bị xoá.',
    timing: 'Khi nào',
    timingOption: { END_OF_PERIOD: 'Khi hết kỳ', IMMEDIATE: 'Ngay bây giờ' },
    done: 'Đã ghi nhận yêu cầu. Trạng thái kỹ thuật bên nhà cung cấp có thể chưa thay đổi; xem trạng thái bên nhà cung cấp để đối chiếu.',
    submit: 'Xác nhận',
  },
};
